export default __webpack_public_path__ + "navigation-examples-custom-location-indicator-thumbnail-480-071018b9d63307eae9de4a09b9b05efa.webp";